import api from "./friends";
const meteCode = {
  namespaced: true,
  state: {
    STATUSCODE: [],
    YESNOCODE: [],
    ICONCODE: [],
    TEMPAAA: [],
    METACODE: {
      LCODE: "00",
      MCODE_STATUSCODE: "00",
      MCODE_YESNO: "01",
      MCODE_ICON: "03",
    },
  },
  getters: {
    GE_LCODE: (state) => state.METACODE.LCODE,
    GE_MCODE_STATUSCODE: (state) => state.METACODE.MCODE_STATUSCODE,
    GE_MCODE_YESNO: (state) => state.METACODE.MCODE_YESNO,
    GE_MCODE_ICON: (state) => state.METACODE.MCODE_ICON,

    GE_STATUSCODE: (state) => state.STATUSCODE,
    GE_YESNOCODE: (state) => state.YESNOCODE,
    GE_ICONCODE: (state) => state.ICONCODE,
  },
  mutations: {
    MU_STATUSCODE: (state, payload) => {
      state.STATUSCODE = payload.data;
    },
    MU_YESNOCODE: (state, payload) => {
      state.YESNOCODE = payload.data;
    },
    MU_ICONCODE: (state, payload) => {
      state.ICONCODE = payload.data;
    },
    MU_NULL: (state, payload) => {
      state.TEMPAAA = payload.data;
    },
  },
  actions: {
    async STATUSCODE({ commit }, payload) {
      const response = await api.meteCode(payload);
      commit("MU_STATUSCODE", response);
      return response;
    },
    async YESNOCODE({ commit }, payload) {
      const response = await api.meteCode(payload);
      commit("MU_YESNOCODE", response);
      return response;
    },
    async ICONCODE({ commit }, payload) {
      const response = await api.meteCode(payload);
      commit("MU_ICONCODE", response);
      return response;
    },
    async CREATE_CODE({ commit }, payload) {
      const response = await api.sysCode(payload);
      return response;
    },
    async SYSCODE({ commit }, payload) {
      const response = await api.sysCode(payload);
      return response;
    },
  },
};

export default meteCode;
